import { render, staticRenderFns } from "./ModifyOrederInfo.vue?vue&type=template&id=1ce4d62c&"
import script from "./ModifyOrederInfo.vue?vue&type=script&lang=js&"
export * from "./ModifyOrederInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModifyOrederInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports